import { Menu, MenuButton, MenuItem as HeadlessMenuItem, MenuItems, MenuSection, MenuSeparator } from "@headlessui/react";
import { ArrowLeftEndOnRectangleIcon, Cog8ToothIcon, UserCircleIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/solid";
import { ReactNode } from "react";

import { useAppDispatch } from "../../../store";
import { uiActions } from "../slice";
import { api } from '../../account/api';
import { useAccount } from '../../account/hooks';
import { SubscriptionBadge } from './SubscriptionBadge';

const MenuItem = ({ children, onClick }: { children: ReactNode, onClick?: () => void }) => (
  <HeadlessMenuItem>
    <div
      className='my-2 py-2 px-4 hover:bg-jw-mid-blue cursor-pointer flex items-center'
      onClick={onClick}
    >
      { children }
    </div>
  </HeadlessMenuItem>
);

export const AccountMenu = () => {

  const userAccount = useAccount();
  const [logOut] = api.useLogOutMutation();
  const dispatch = useAppDispatch();

  const doLogout = () => {
    logOut();
    dispatch(api.util.resetApiState());
  };

  return (
    <div className='flex p-2 items-center'>
      <div className='flex grow shrink truncate'>
        <UserCircleIcon className='size-6 mr-2' />
        <b
          className='truncate'
          title={userAccount?.email}
        >
          { userAccount?.email || 'Not logged in' }
        </b>
        {
          userAccount && (
            <SubscriptionBadge subscriptionStatus={userAccount.subscription_status} />
          )
        }
      </div>
      <Menu>
        <MenuButton className='p-1 hover:bg-jw-mid-blue data-[active]:bg-jw-light-blue rounded-sm'>
          <Cog8ToothIcon className='size-6' />
        </MenuButton>
        <MenuItems
          anchor='top end'
          className='w-[250px] bg-jw-blue rounded-sm text-white z-50 border shadow transition duration-150 ease-out data-[closed]:opacity-0'
          transition
        >
          <MenuSection>
            <MenuItem
              onClick={() => dispatch(uiActions.setCurrentModal({ modal: 'account' }))}
            >
              <UserCircleIcon className='size-5 mr-2' />
              Manage account
            </MenuItem>
            <MenuItem
              onClick={() => dispatch(uiActions.setCurrentModal({ modal: 'settingsDialog' }))}
            >
              <WrenchScrewdriverIcon className='size-5 mr-2' />
              Settings
            </MenuItem>
          </MenuSection>
          <MenuSeparator
            as='hr'
            className='my-2'
          />
          <MenuSection>
            <MenuItem
              onClick={doLogout}
            >
              <ArrowLeftEndOnRectangleIcon className='size-5 mr-2' />
              Log out
            </MenuItem>
          </MenuSection>
        </MenuItems>
      </Menu>
    </div>
  );
};
